<template>
    <div>
        <el-form ref="form" :inline="true" class="query-form" size="mini" @submit.native.prevent="onSubmit">
            <el-form-item label="" prop="status">
                <el-radio-group v-model="query.dataRange">
                    <el-radio-button :label="7">近7天</el-radio-button>
                    <el-radio-button :label="30">近30天</el-radio-button>
                    <el-radio-button :label="90">近90天</el-radio-button>
                </el-radio-group>
            </el-form-item>
            <el-form-item label="开始时间：">
                <el-date-picker
                    style="width: 140px"
                    v-model="query.begin_date"
                    type="date"
                    size="mini"
                    placeholder="选择开始时间"
                    value-format="yyyy-MM-dd"
                >
                </el-date-picker>
            </el-form-item>
            <el-form-item label="结束时间：">
                <el-date-picker
                    style="width: 140px"
                    v-model="query.end_date"
                    type="date"
                    size="mini"
                    placeholder="选择结束时间"
                    value-format="yyyy-MM-dd"
                >
                </el-date-picker>
            </el-form-item>
            <el-button type="primary" @click="onSubmit" size="mini" native-type="submit">查询</el-button>
        </el-form>
        <el-table v-loading="loading" :data="list" :height="tableHeight" size="mini" 
                  @row-click="clickRowHandle" @header-click="clickHeaderHandle"
                  class="table_content mini_div" border @sort-change="handleSortChange" style="width: 100%;">

            <el-table-column label="账号" min-width="120" align="center">
                <template slot-scope="scope">
                    <div class="fixedHeight">{{ scope.row.username }}</div>
                </template>
            </el-table-column>
            <el-table-column label="人员" min-width="120" align="center">
                <template slot-scope="scope">
                    <div class="fixedHeight">{{ scope.row.full_name }}</div>
                </template>
            </el-table-column>
            <el-table-column label="国家" min-width="50" align="center">
                <template slot-scope="scope">
                    <div v-for="preStr in prefixArr">
                        {{ prefixObj[preStr] }}
                    </div>
                </template>
            </el-table-column>

            <el-table-column label="总数" min-width="150" align="center">
                <template slot-scope="scope">
                    <div v-for="preStr in prefixArr">
                        {{ scope.row.end_date_datas[preStr + '_total_count'] || 0 }}
                        <span v-if="getNumDiff(scope.row, '_total_count', preStr)['flag']"
                              :class="{'greenTxt': (getNumDiff(scope.row, '_total_count', preStr)['num'] > 0),
                            'redTxt':((getNumDiff(scope.row, '_total_count', preStr)['num'] || 0) < 0) }">
                        (
                            {{ getNumDiff(scope.row, '_total_count', preStr)['num'] }}
                            <i class="el-icon-top"
                               v-show="getNumDiff(scope.row, '_total_count', preStr)['num'] > 0"/>
                            <i class="el-icon-bottom"
                               v-show="getNumDiff(scope.row, '_total_count', preStr)['num'] < 0"/>
                                )
                        </span>
                    </div>
                </template>
            </el-table-column>

            <el-table-column label="待制作" min-width="150" align="center">
                <template slot-scope="scope">
                    <div v-for="preStr in prefixArr">
                        {{ scope.row.end_date_datas[preStr + '_wait_product_count'] || 0 }}
                        <span v-if="getNumDiff(scope.row, '_wait_product_count', preStr)['flag']"
                              :class="{'greenTxt': (getNumDiff(scope.row, '_wait_product_count', preStr)['num'] > 0),
                            'redTxt':((getNumDiff(scope.row, '_wait_product_count', preStr)['num'] || 0) < 0) }">
                        (
                            {{ getNumDiff(scope.row, '_wait_product_count', preStr)['num'] }}
                            <i class="el-icon-top"
                               v-show="getNumDiff(scope.row, '_wait_product_count', preStr)['num'] > 0"/>
                            <i class="el-icon-bottom"
                               v-show="getNumDiff(scope.row, '_wait_product_count', preStr)['num'] < 0"/>
                                )
                        </span>
                    </div>
                </template>
            </el-table-column>

            <el-table-column label="待分配" min-width="150" align="center">
                <template slot-scope="scope">
                    <div v-for="preStr in prefixArr">
                        {{ scope.row.end_date_datas[preStr + '_wait_assign_count'] || 0 }}
                        <span v-if="getNumDiff(scope.row, '_wait_assign_count', preStr)['flag']"
                              :class="{'greenTxt': (getNumDiff(scope.row, '_wait_assign_count', preStr)['num'] > 0),
                            'redTxt':((getNumDiff(scope.row, '_wait_assign_count', preStr)['num'] || 0) < 0) }">
                        (
                            {{ getNumDiff(scope.row, '_wait_assign_count', preStr)['num'] }}
                            <i class="el-icon-top"
                               v-show="getNumDiff(scope.row, '_wait_assign_count', preStr)['num'] > 0"/>
                            <i class="el-icon-bottom"
                               v-show="getNumDiff(scope.row, '_wait_assign_count', preStr)['num'] < 0"/>
                                )
                        </span>
                    </div>
                </template>
            </el-table-column>

            <el-table-column label="已分配" min-width="150" align="center">
                <template slot-scope="scope">
                    <div v-for="preStr in prefixArr">
                        {{ scope.row.end_date_datas[preStr + '_finish_assign_count'] || 0 }}
                        <span v-if="getNumDiff(scope.row, '_finish_assign_count', preStr)['flag']"
                              :class="{'greenTxt': (getNumDiff(scope.row, '_finish_assign_count', preStr)['num'] > 0),
                            'redTxt':((getNumDiff(scope.row, '_finish_assign_count', preStr)['num'] || 0) < 0) }">
                        (
                            {{ getNumDiff(scope.row, '_finish_assign_count', preStr)['num'] }}
                            <i class="el-icon-top"
                               v-show="getNumDiff(scope.row, '_finish_assign_count', preStr)['num'] > 0"/>
                            <i class="el-icon-bottom"
                               v-show="getNumDiff(scope.row, '_finish_assign_count', preStr)['num'] < 0"/>
                                )
                        </span>
                    </div>
                </template>
            </el-table-column>
        </el-table>
        <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :page-size="query.limit"
                       :page-sizes="[10, 20, 50]" :total="query.total" background :current-page="query.page"
                       style="margin-top: 10px; display: flex;justify-content: end;"
                       layout="total, sizes, prev, pager, next">
        </el-pagination>
    </div>
</template>

<script>
import * as api from '@/api/advAnalys/advAnalys.js'
import { getRunningStates } from '@/api/common/common.js'

export default {
    name: 'linkProductionStatistics',
    watch: {
        tableHeight(val) {
            this.tableHeight = val
        },
        'query.dataRange': {
            handler(value) {
                value = value - 1
                this.query.begin_date = new Date(Date.now() - value * 24 * 60 * 60 * 1000)
                this.query.end_date = new Date()
                this.initRunningStates()
            },
            immediate: true,
            deep: true
        }
    },
    data() {
        return {
            prefixObj: { ev: '总' },
            prefixArr: ['ev'],
            tableHeight: null,
            loading: false,
            query: {
                dataRange: 7,
                begin_date: undefined,
                end_date: undefined,
                page: 1,
                limit: 10,
                total: 0,
            },
            list: [],
        }
    },
    mounted() {
        this.tableHeight = window.innerHeight - 140 - this.$refs.form.$el.offsetHeight
        const that = this
        window.onresize = () => {
            return (() => {
                if (typeof that.$refs.form == 'object') {
                    that.tableHeight =
                        window.innerHeight -
                        140 -
                        that.$refs.form.$el.offsetHeight
                }
            })()
        }
    },
    methods: {
        getNumDiff(obj, variableStr, preStr) {
            let res = {flag: false, num: 0}
            if (obj.begin_date_datas && obj.end_date_datas) {
                res = {
                    flag: true,
                    num: (obj.end_date_datas[preStr + variableStr] || 0) - (obj.begin_date_datas[preStr + variableStr] || 0)
                }
            }
            return res
        },
        formatDate(date) {
            const yyyy = date.getFullYear()
            const mm = String(date.getMonth() + 1).padStart(2, '0')
            const dd = String(date.getDate()).padStart(2, '0')
            return `${yyyy}-${mm}-${dd}`
        },
        clickRowHandle(row, column) {
            if (['标题', '类目树', '子类目', '1688产品标题', '颜色'].includes(column.label)) {
                this.childInfo = {
                    title: column.label,
                    info: row[column.prop]
                }
                this.ctrl.childInfoVisible = true
            }
        },
        clickHeaderHandle(row, column) {
            if (['折叠', '收起'].includes(row.label)) {
                this.isFold = !this.isFold
            }
        },
        handleSortChange(val) {
            if (val.order == 'ascending') {
                this.query.desc = 'desc'
                this.query.order = val.prop
            } else if (val.order == 'descending') {
                this.query.desc = 'asc'
                this.query.order = val.prop
            }
            this.getList()
        },
        // 查询
        onSubmit() {
            this.query.page = 1
            this.getList()
        },
        // 获取列表数据
        getList() {
            this.loading = true
            let tempQuery = JSON.parse(JSON.stringify(this.query))
            tempQuery.begin_date = this.formatDate(new Date(tempQuery.begin_date))
            tempQuery.end_date = this.formatDate(new Date(tempQuery.end_date))
            
            api.manager_statistics_statistics_producer(tempQuery).then(res => {
                this.loading = false
                if (res.code === 0) {
                    const responseList = res.data.list || []
                    const states = (this.prefixArr || []).filter(s => s !== 'ev')

                    responseList.forEach(row => {
                        row.begin_date_datas = row.begin_date_datas || {}
                        row.end_date_datas = row.end_date_datas || {}

                        // 计算总和 ev_* 字段
                        ;['_total_count', '_wait_product_count', '_wait_assign_count', '_finish_assign_count'].forEach(suffix => {
                            const sumBegin = states.reduce((acc, st) => acc + (Number(row.begin_date_datas[st + suffix]) || 0), 0)
                            const sumEnd = states.reduce((acc, st) => acc + (Number(row.end_date_datas[st + suffix]) || 0), 0)
                            row.begin_date_datas['ev' + suffix] = sumBegin
                            row.end_date_datas['ev' + suffix] = sumEnd
                        })
                    })

                    this.list = responseList
                    this.query.total = res.data.total
                } else {
                    this.$message({
                        type: 'error',
                        message: res.message
                    })
                }
            }).catch(() => {
                this.loading = false
            })
        },
        // 分页
        handleCurrentChange(val) {
            this.query.page = val
            this.getList()
        },
        handleSizeChange(val) {
            this.query.limit = val
            this.getList()
        },
        // 初始化国家列表
        async initRunningStates() {
            try {
                const res = await getRunningStates()
                if (res && (res.code === 0 || res.success)) {
                    const list = (res.data || []).map(item => ({
                        state: (item.state || '').toLowerCase(),
                        cn_state: item.cn_state
                    })).filter(item => item.state)

                    const obj = {}
                    const arr = []
                    list.forEach(item => {
                        obj[item.state] = item.cn_state
                        arr.push(item.state)
                    })

                    // 添加总计行
                    obj.ev = '总'
                    arr.push('ev')

                    this.prefixObj = obj
                    this.prefixArr = arr

                    // 获取列表数据
                    this.getList()
                } else {
                    this.$message({
                        type: 'error',
                        message: (res && res.message) || '获取国家列表失败'
                    })
                }
            } catch (e) {
                this.$message({
                    type: 'error',
                    message: '获取国家列表失败'
                })
            }
        }
    }
}
</script>

<style type="text/scss" lang="scss" scoped>
.redTxt {
    color: red;
    font-weight: bold;
}

.greenTxt {
    color: green;
    font-weight: bold;
}

.fixedHeight {
    height: 30px;
    line-height: 15px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: normal;
    display: flex;
    justify-content: center;
    align-items: center;
}

.mini_div .el-button--mini {
    padding: 5px 5px !important;
}

/deep/ .el-table__expanded-cell {
    padding: 0 0 !important;
}
</style>
